// extracted by mini-css-extract-plugin
export default {"title":"Card_title__fjt9r","body":"Card_body__RHED-"};